export const getDonorDisplayName = (donor) => {
  if (donor.first_name && donor.last_name) {
    return `${donor.first_name} ${donor.last_name}`;
  }

  if (donor.full_name) {
    return donor.full_name;
  }

  return "No name assigned";
};
